var _defs, _rect, _rect2, _rect3, _circle, _path, _text, _text2, _rect4, _text3, _text4, _text5, _text6, _text7, _text8, _rect5, _circle2, _text9, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _text0, _path2, _rect54, _circle3, _text1, _text10, _rect55, _text11, _text12, _text13, _text14, _text15, _text16, _text17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportDigitalPassportVerifiableStatusMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 620,
    height: 1160,
    viewBox: "0 0 620 1160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Work Passport digital passport mobile visual") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wp-dp-mobile-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF3FD"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "wp-dp-mobile-shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 16,
    stdDeviation: 22,
    floodColor: "#07152A",
    floodOpacity: 0.14
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 584,
    height: 1124,
    rx: 36,
    fill: "#F8FBFE",
    stroke: "#D2E1F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 56,
    width: 516,
    height: 626,
    rx: 28,
    fill: "url(#wp-dp-mobile-bg)",
    stroke: "#BFD8EE",
    filter: "url(#wp-dp-mobile-shadow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 56,
    width: 9,
    height: 626,
    rx: 4.5,
    fill: "#30D6A1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 124,
    r: 31,
    fill: "#E7F8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 124l10 10 20-23",
    fill: "none",
    stroke: "#19AF7C",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 112,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 850,
    letterSpacing: 1.7
  }, "WORK PASSPORT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 144,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "Ready for deployment")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 184,
    width: 444,
    height: 1,
    fill: "#D2E1F2"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 226,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 760
  }, "EMPLOYEE")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 236,
    y: 226,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 820
  }, "Thabo Mokoena")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 270,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 760
  }, "SITE")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 236,
    y: 270,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 820
  }, "North Processing Plant")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 314,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 760
  }, "POSITION")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 236,
    y: 314,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 820
  }, "Maintenance Technician")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 350,
    width: 444,
    height: 64,
    rx: 18,
    fill: "#E7F8F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 382,
    r: 7,
    fill: "#30D6A1"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 138,
    y: 388,
    fill: "#08755A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 820
  }, "11 of 11 requirements current")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 446,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 446,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 446,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 446,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 446,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 446,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 446,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 446,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 446,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 466,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 466,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 466,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 466,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 486,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 486,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 486,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 486,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 486,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 506,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 506,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 506,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 506,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 526,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 526,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 526,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 526,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 546,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 546,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 546,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 546,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 546,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 546,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 566,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 566,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 566,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 566,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 586,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 586,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 586,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 586,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 586,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 606,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 606,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 606,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 606,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 606,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 606,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 606,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 606,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 606,
    width: 14.399999999999999,
    height: 14.399999999999999,
    rx: 1.6,
    fill: "#07152A"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 650,
    textAnchor: "middle",
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 760
  }, "SCAN FOR LIVE STATUS")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310 700v42m-8-9 8 9 8-9",
    fill: "none",
    stroke: "#8BCBFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 768,
    width: 516,
    height: 318,
    rx: 26,
    fill: "#07152A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 826,
    r: 10,
    fill: "#30D6A1"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: 820,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "LIVE SYSTEM STATUS")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: 854,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 850
  }, "Passport current")), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 894,
    width: 448,
    height: 1,
    fill: "#29405D"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 934,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 680
  }, "Employee identity")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 516,
    y: 934,
    textAnchor: "end",
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 850
  }, "VERIFIED")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 976,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 680
  }, "Site and position")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 516,
    y: 976,
    textAnchor: "end",
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 850
  }, "MATCHED")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 1018,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 680
  }, "Evidence validity")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 516,
    y: 1018,
    textAnchor: "end",
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 850
  }, "CURRENT")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 1062,
    fill: "#6F87A4",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 730
  }, "Last checked today at 07:42")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportDigitalPassportVerifiableStatusMobile);
export default __webpack_public_path__ + "static/media/work-passport-digital-passport-verifiable-status-mobile.505466c5fad82f7fd517be0175133c0d.svg";
export { ForwardRef as ReactComponent };